import timeBits from './helpers/data/timeBits'
import complaints from './helpers/data/complaints'
import areas from './helpers/data/areas'
import userTypes from './helpers/data/userTypes'
import status from './helpers/data/status'
import channels from './helpers/data/channels'
import practiceFeatures from './helpers/data/practiceFeatures'

import debounce from './helpers/debounce'
// import uppercase from 'helpers/data/uppercase'

function getDay() {
  const dt = new Date()
  return dt.getDay() === 0 ? 7 : dt.getDay()
}

function getAreaName(id) {
  return areas.find((a) => a.uid === id).name
}

export default {
  getDay,
  timeBits,
  complaints,
  areas,
  getAreaName,
  userTypes,
  status,
  channels,
  practiceFeatures,
  debounce
}
